import { AxiosInstance, AxiosRequestConfig } from 'axios';

import axios, { IRestResponse } from './axios';
import centrifuge, { Client } from './centrifuge';

class Backend {
	_axios: AxiosInstance;

	_centrifuge: Client;

	constructor(axios: AxiosInstance, centrifuge: Client) {
		this._axios = axios;
		this._centrifuge = centrifuge;
	}

	async login(token: string, _: string) {
		this._axios.defaults.headers.common.Authorization = `Bearer ${token}`;
		// await this._centrifuge.connect(token, centrifugo_channel);
	}

	logout() {
		delete this._axios.defaults.headers.common.Authorization;
		// this._centrifuge.disconnect();
	}

	async _request(config: AxiosRequestConfig) {
		try {
			const response: IRestResponse = await this._axios.request({
				...config,
			});
			// const result = await this._centrifuge.subscribe(response?.request_id, config, response);
			return response?.data ? response.data : response;
		} catch (e) {
			console.error('Backend', e);
			throw e;
		}
	}

	async get(url: string, config: AxiosRequestConfig = {}) {
		return this._request({
			...config,
			url,
			method: 'get',
		});
	}

	async post(url: string, data: any, config: AxiosRequestConfig = {}) {
		return this._request({
			...config,
			url,
			method: 'post',
			data,
		});
	}

	async patch(url: string, data: any, config: AxiosRequestConfig = {}) {
		return this._request({
			...config,
			url,
			method: 'patch',
			data,
		});
	}

	async put(url: string, data: any, config: AxiosRequestConfig = {}) {
		return this._request({
			...config,
			url,
			method: 'put',
			data,
		});
	}

	async delete(url: string, data?: any, config: AxiosRequestConfig = {}) {
		return this._request({
			...config,
			url,
			method: 'delete',
			data,
		});
	}

	async uploadFile(file: File | Blob, onProgress?: (progress: number) => void) {
		const formData = new FormData();
		formData.append('file', file);

		const response = await this._axios.post('/media', formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			onUploadProgress: (progressEvent) => {
				if (onProgress) {
					const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					onProgress(progress);
				}
			},
		});
		return response?.data;
	}
}

export default new Backend(axios, centrifuge);
